import { IEmailAttachment } from './interfaces/email-attachment.interface';
import { IEmail } from './interfaces/email.interface';

export class Email implements IEmail {
    fromAddressId: number = -1;
    to: string[];
    cc: string[];
    cci: string[];
    subject: string;
    body: string;
    attachments: Map<string, File>;
    predefinedAttachments: IEmailAttachment[];
}
